import {Helmet} from 'react-helmet-async';

import {_fiscal_year, _mock} from 'src/_mock';
import {_app_details_name} from 'src/_mock/assets_App_Rationalization';

import {_app_costs_cost_list} from 'src/_mock/appCosts_assets';
import QAWrapperComponent from './QAWrapperComponent/QAWrapperComponent';

const AppCosts = () => {
  const _column_data: any = {
    type: {
      // 'Application Name': 'text',
      Category: 'text',
      Cost: 'currency',
      Type: 'singleSelect'
    },
    options: {
      Type: ['CapEx', 'OpEx']
    },
    column_questions: {
      // 'Application Name': 'text',
      'DB Size(TB)': 'What is the size of the database in TB?',
      'Total Size(TB)':
        'What is the total data footprint (in TB) of the application including documents, images, etc?',
      'Audit Log(TB)': 'How much data is stored in user/audit logs?',
      Comments:
        'What other technical details would be helpful to know about this application?',
      Frequency: 'How often is the application used?',
      Expansion:
        'How well does this application scale to handle greater transaction volumes and support additional users (internal or external to your organization)?',
      Training: 'How difficult is it to onboard and train a new user?',
      BI: 'Does this application integrate with a BI tool?',
      Revenue: 'Does this application generate revenue?',
      Growth: 'Revenue growth potential?',
      Uniqueness:
        "Is this application's functionality similar to another already used by your organization?",
      Stability: 'How stable is the system?',
      Maintenance: 'number',
      'Outage Impact':
        'How does a 24 hour, unplanned outage of this application impact your organization?',
      Value: "What is the application's business value?",
      'Sole Source':
        'Is the application is an authoritative source or Exclusive Record of Origin (ROO) for the stored data?',
      Redundancy: 'What level of redundancy is used for application continuity?'
    },
    renderCell: {},
    renderEditCell: {}
  };
  const gridData: any = {};

  const modifyGridData = (Obj_key: any, gridData_obj: any) => {
    const output: any = {
      [Obj_key]: {
        titles: [...Array(10)].map((_, index) => `FY ${_fiscal_year[index]}`)
      }
    };
    // eslint-disable-next-line
    for (let i = 0; i < 10; i++) {
      const dataGridKey = `_dataGrid_${i}`;
      output[Obj_key][dataGridKey] = [...Array(8)].map((_, index) => ({
        id: _mock.id(index),
        Category: _mock.app_costs.category(index),
        Cost: _app_costs_cost_list?.[`${Obj_key}_${i}`]?.[index],
        Type: _mock.app_costs.type(index)
      }));
    }

    gridData_obj[Obj_key] = output[Obj_key];
  };

  _app_details_name.map((item: any) => modifyGridData(item, gridData));

  const TABS = _app_details_name.map((item: any) => ({
    value: item,
    label: item
  }));

  return (
    <>
      <Helmet>
        <title> Dashboard: Security/Infra</title>
      </Helmet>

      <QAWrapperComponent
        TABS={TABS}
        gridData={gridData}
        _column_data={_column_data}
        title="App Costs"
        initialState={{
          aggregation: {
            model: {
              Cost: 'sum',
              Category: 'display_title'
            }
          }
        }}
      />
    </>
  );
};

export default AppCosts;
